import React from "react";
import { Dropdown, DropdownButton } from "react-bootstrap";
import AddToolTip from "../AddToolTip/AddToolTip";

const DropdownAsButton = ({ label, variant, options, onClick, disabled }) => {
  return (
    <DropdownButton
      title={label}
      style={{ width: "300px" }}
      align="end"
      variant={variant}
      id="dropdown-menu-align-end"
      className={"request-dropdown"}
      disabled={disabled}
    >
      {options.map((data) => (
        <>
          <Dropdown.Divider />
          {data.disabled ? (
            <AddToolTip name={data.message}>
              <div className="grey-text" style={{ padding: "0.25rem 1.5rem" }}>
                {data.label}
              </div>
            </AddToolTip>
          ) : (
            <Dropdown.Item
              onClick={(evt) => {
                !data.disabled ? onClick(data.value) : evt.preventDefault();
              }}
              // disabled={data.disabled}
            >
              {/* <Link
              to={getPathWithParam({
                path: data.path,
                pathParam: data.pathParam,
              })}
            > */}
              {data.label}
              {/* </Link> */}
            </Dropdown.Item>
          )}
        </>
      ))}
    </DropdownButton>
  );
};

export default DropdownAsButton;
